<template>
    <div class="card wos__card rounded-lg m-4 shadow justify-content-between w-100">
        <div class="card-header">
            <a @click="showConfigurations" href="javascript:void(0)">
                <span class="discount-badge">
                    {{`${quantity} ${unit}`}}
                </span>
                <img class="card-img-top wos__image-link top-rounded-img_lg" :alt="catalogNo" :src="thumbnail">
            </a>
        </div>
        <div class="card-body">
            <h4 class="card-title wos__card-title w-100 text-overflow-hide">{{catalogName}}</h4>
            <a class="text-wellis-gold" @click="showConfigurations" href="javascript:void(0)">
                <h6 class="card-subtitle mb-2">{{catalogNo}}</h6>
            </a>
            <p class="mt-1 font-weight-bold card-subtitle text-muted">
                {{$t('components.stocklist.sum-quantity')}}<span class="d-block text-wellis-gold">{{`${quantity} ${unit}`}}</span>
            </p>
            <p class="mt-1 font-weight-bold card-subtitle text-muted">
                {{$t('components.stocklist.unique-configs')}}: <span class="text-wellis-gold">{{configsCount}}</span>
            </p>
        </div>
        <div class="card-footer">
            <button class="btn btn-wos-real col-sm-12 mt-5" @click="showConfigurations">
                {{$t('components.stocklist.btnShowConfigurations')}}
            </button>
        </div>
        <transition name="bounce">
            <StockFifoProductConfigurations v-if="showConfigurationsModal"
                                            :configurations="configurations"
                                            :catalog-no="catalogNo"
                                            :name="catalogName"
                                            :btn-configurator="btnConfigurator"
                                            :btn-add-cart="btnAddCart"
                                            @close="toggleConfigurationsModal"/>
        </transition>
    </div>
</template>

<script>
    import StocklistApiService from "../../api/stocklist.api";
    import StockFifoProductConfigurations from "./StockFifoProductConfigurations";

    export default {
        name: "StockFifoProductCard",
        components: {StockFifoProductConfigurations},
        props: {
            stockItem: Object,
            btnConfigurator: Boolean,
            btnAddCart: Boolean,
        },

        created() {
            this.product = this.stockItem;
        },

        data() {
            return {
                product: {},
                showConfigurationsModal: false
            }
        },

        methods: {
            showConfigurations() {
                let loader = this.$loading.show();
                let data = [];
                Object.values(this.product.configs).forEach(item => {
                    data.push({
                        catalog_no: this.product.catalogNo,
                        config_no: item.configNo,
                        contract: item.contract
                    });
                });

                StocklistApiService.getConfigurationsPrice(data)
                    .then(response => {
                        response.data.configs.forEach(item => {
                            this.product.configs[item.config_no].price = item.price;
                        });
                        this.toggleConfigurationsModal();
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            },

            toggleConfigurationsModal() {
                this.showConfigurationsModal = !this.showConfigurationsModal;
                if (this.showConfigurationsModal) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            },
        },

        computed: {
            catalogNo() {
                if (!this.product) {
                    return 'N/A';
                }
                return this.product.catalogNo;
            },

            catalogName() {
                if (!this.product) {
                    return 'N/A';
                }
                return this.product.name;
            },

            thumbnail() {
                if (!this.product) {
                    return null;
                }
                return this.product.media.thumbnailUrl;
            },

            configsCount() {
                if (!this.product) {
                    return null;
                }
                return Object.values(this.product.configs).length;
            },

            quantity() {
                if (!this.product) {
                    return 0;
                }
                let quantity = 0;
                Object.values(this.product.configs).forEach(item => {
                    quantity += parseInt(item.quantity);
                });
                return quantity;
            },

            configurations() {
                return Object.values(this.product.configs);
            },

            unit() {
                if (!this.product) {
                    return 'N/A';
                }
                return this.product.unit;
            }
        }
    }
</script>

<style scoped>
    .discount-badge {
        position: absolute;
        right: 0;
        font-size: 14px;
    }


    .bounce-enter-active {
        animation: bounce-in .5s;
    }

    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }

    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }
</style>
